import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
    Card,
    Col,
    Divider,
    Row,
    Typography,
    Spin,
    Button
} from "antd";

//ANT DESIGN ICONS IMPORTS
import {
    LeftOutlined,
} from "@ant-design/icons";


//PROJECT IMPORTS
import cnt from "../../../../../services/definedConstant";
import { staticConfig, labelConfig, apiConfig } from "../../../customer.config";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { BOM } from "../../../../../services/definedMethod";
import { rightAction } from "../../../../../redux/actions";

const { Text } = Typography;

const ManageAccountAction = (props) => {
    const { userData, rightAction } = props
    const { session } = userData;
    const { state } = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [accountDetails, setAccountDetails] = useState();

    useEffect(() => {
        getCurrentAccDetailById();
        {BOM.HasPermission("MANAGE_ACCOUNT_UPDATE") && rightAction(cnt.RIGHT_EDIT_BTN)};
    }, []);

    const getCurrentAccDetailById = () => {
        setIsLoading(true);
        const url = `${apiConfig.savingsaccountdetails}/${state.id}`;

        let body = {
            session,
        };

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;

                setAccountDetails(objDetail)
                setIsLoading(false);
            }
        });
    };

    function onCancel() {
        navigate("/detail-current-account", { state: state });
    }
    const handleOnEdit = () => {
        navigate("/edit-manage-current-account", { state: state });
    }

    return (

        <MainLayout
            isEnableRightSidebar={true}
            onEdit={handleOnEdit}
        >
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent
                pageTitle={labelConfig.viewManagedAccountDetails}
                pageItems={staticConfig.viewManagedAccountDetailsCurrentAccBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    style={{
                        marginBottom: "2%",
                        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    }}
                    title={
                        <Row
                            style={{
                                alignContent: "center",
                                width: "8%",
                            }}
                        >
                            <Button
                                icon={<LeftOutlined />}
                                type="text"
                                style={{
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                }}
                                onClick={onCancel}
                            >
                                <Text
                                    style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                                >
                                    Back
                                </Text>
                            </Button>
                        </Row>
                    }
                >
                    <div
                        style={{
                            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                            marginBottom: 25,
                        }}
                    >
                        <Divider orientation="left" orientationMargin="0">
                            {`Account No: ${state.accountNo}`}
                        </Divider>
                        <Row>
                            <ManageCurrAccDetails accountDetails={accountDetails} />
                        </Row>
                    </div>
                </Card>
            </Spin>
        </MainLayout>
    );
};

const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {
    rightAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ManageAccountAction);

function ManageCurrAccDetails(props) {
    const { accountDetails } = props;
    const manageAccountData1 = [
        {
            label: "Days Past Due",
            value: accountDetails?.daysPastDue,
        },
        {
            label: "Facility Reference",
            value: "-",
        },
        {
            label: "Last Rate Change Date",
            value: BOM.DateTime(accountDetails?.lastRateChangeDate, "only-date"),
        },
        {
            label: "YTD Interest Earned",
            value: `${accountDetails?.finYtdInterestEarned}`,
        },
        {
            label: "FIN Interest Earned",
            value: "-",
        },
        {
            label: "Contract Reference",
            value: "-",
        },
        {
            label: "DSG Insured Amount",
            value: `${accountDetails?.dsgInsuredAmount}`,
        },
        {
            label: "DSG Uninsured Amount",
            value: `${accountDetails?.dsgUninsuredAmount}`,
        },
        {
            label: "Hedging Portfolio Ref",
            value: "-",
        },
        {
            label: "Repo Reference Cash Leg",
            value: "-",
        },
        {
            label: "Universal Source System",
            value: "-",
        },
        {
            label: "Universal Branch Id",
            value: "-",
        },
        {
            label: "Account Holder Indicator",
            value: "-",
        },
        {
            label: "Account Status Code",
            value: "-",
        },
        {
            label: "Extension Code",
            value: "-",
        },
        {
            label: "Jurisdiction",
            value: "-",
        },
        {
            label: "Bank Recovery",
            value: "-",
        },
        {
            label: "Sort Code",
            value: "-",
        },
        {
            label: "Dormant Date",
            value: BOM.DateTime(accountDetails?.dormantDate, "only-date"),
        },
        {
            label: "Debit Interest Rate",
            value: `${accountDetails?.debitInterestRate}`,
        },
        {
            label: "Portfolio Type",
            value: "-",
        },
        {
            label: "IFRS9 Portfolio Type",
            value: "-",
        },
        {
            label: "Rate Spread",
            value: `${accountDetails?.rateSpread}`,
        },
        {
            label: "Date of Performance Status Change",
            value: BOM.DateTime(accountDetails?.perfStatusChangeDate, "only-date"),
        },
        {
            label: "Performing Status",
            value: "-",
        },
        {
            label: "Symmetrical Inflow Rate",
            value: `${accountDetails?.symmetricalInflowRate}`,
        },
        {
            label: "Last Interest Capitalisation Date",
            value: BOM.DateTime(accountDetails?.dateLastIntCap, "only-date"),
        },
        {
            label: "Universal HQLA Indicator",
            value: `${accountDetails?.HQLAInd}`,
        },
        {
            label: "Client Money Placed",
            value: `${accountDetails?.clientMoneyPlaced}`,
        },
    ]
    const manageAccountData2 = [
        {
            label: "Deposit Iban",
            value: "-",
        },
        {
            label: "External Account No",
            value: "-",
        },
        {
            label: "Swift Code",
            value: "-",
        },
        {
            label: "Ach Routing No",
            value: "-",
        },
        {
            label: "Wire Routing No",
            value: "-",
        },
        {
            label: "BBAN",
            value: "-",
        },
        {
            label: "UPIC",
            value: "-",
        },
        {
            label: "BIC",
            value: "-",
        },
        {
            label: "Local Currency Code",
            value: "-",
        },
        {
            label: "Account Balance Local Currency",
            value: `${accountDetails?.accountBalanceLocalCurrency}`,
        },
        {
            label: "Non Performing",
            value: `${accountDetails?.nonPerforming}`,
        },
        {
            label: "Stress Withdrawal",
            value: `${accountDetails?.stressWithdrawal}`,
        },
        {
            label: "Transactional Account",
            value: `${accountDetails?.transactionalAccount}`,
        },
        {
            label: "Suspected Money Laundering",
            value: `${accountDetails?.suspectedMoneyLaundering}`,
        },
        {
            label: "Fraud",
            value: `${accountDetails?.fraud}`,
        },
        {
            label: "Legally Disputed",
            value: `${accountDetails?.legallyDisputed}`,
        },
        {
            label: "Undocumented Account",
            value: `${accountDetails?.undocumentedAccount}`,
        },
        {
            label: "Type of Business Activity",
            value: "-",
        },
        {
            label: "Institution where is the client money placed?",
            value: "-",
        },
        {
            label: "Type of Client Account for CASS",
            value: "-",
        },
        {
            label: "Client Account Acknowledgement Letter",
            value: `${accountDetails?.acknowledgementLetter}`,
        },
        {
            label: "Linked to periodic reference rate",
            value: "-",
        },
        {
            label: "Universal Accumulated Impairment Amount",
            value: `${accountDetails?.accumulatedImpairmentAmount}`,
        },
        {
            label: "Universal GL Marker",
            value: "-",
        },
        {
            label: "Last customer driven transaction",
            value: "-",
        },
        {
            label: "Overdrawn limit",
            value: `${accountDetails?.overdrawnLimitAmount}`,
        },
        {
            label: "Beneficiary",
            value: `${accountDetails?.beneficiary}`,
        },
        {
            label: "Transactional Account Flag (Branch Return)",
            value: `${accountDetails?.transactionalAccountBranchReturn}`,
        },
        {
            label: "Universal Impairment Status",
            value: "-",
        },

    ]
    console.log(accountDetails)
    return (
        <>
            <Col span={12} style={{ paddingRight: 5 }}>
                {manageAccountData1.map((detail, index) => {
                    const { label, value } = detail;

                    return (
                        <Row
                            style={{
                                border: "2px solid #F5F5F5",
                                borderRadius: 15,
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0,
                                borderBottomColor: "#E2E2E2",
                            }}
                            key={index}
                        >
                            <Col
                                span={12}
                                style={{
                                    backgroundColor: "#F5F5F5",
                                    padding: "0px 8px",
                                    borderRadius: 15,
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                    borderBottomLeftRadius: 0,
                                }}
                            >
                                <Text strong>{label}</Text>
                            </Col>
                            <Col
                                span={12}
                                style={{
                                    padding: 10,
                                    textAlign: "center"
                                }}
                            >
                                <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                            </Col>
                        </Row>
                    );
                })}
            </Col>
            <Col span={12} style={{ paddingRight: 5 }}>
                {manageAccountData2.map((detail, index) => {
                    const { label, value } = detail;

                    return (
                        <Row
                            style={{
                                border: "2px solid #F5F5F5",
                                borderRadius: 15,
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0,
                                borderBottomColor: "#E2E2E2",
                            }}
                            key={index}
                        >
                            <Col
                                span={12}
                                style={{
                                    backgroundColor: "#F5F5F5",
                                    padding: "0px 8px",
                                    borderRadius: 15,
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                    borderBottomLeftRadius: 0,
                                    justifyContent: "center",
                                }}
                            >
                                <Text strong>{label}</Text>
                            </Col>
                            <Col
                                span={12}
                                style={{
                                    padding: 10,
                                    textAlign: "center"
                                }}
                            >
                                <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                            </Col>
                        </Row>
                    );
                })}
            </Col>

        </>
    )
}
